import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-profile-saved-listing',
  templateUrl: './profile-saved-listing.component.html',
  styleUrls: ['./profile-saved-listing.component.css']
})
export class ProfileSavedListingComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
